import { render, staticRenderFns } from "./DoctorDetails.vue?vue&type=template&id=6a77a4f7&scoped=true&"
import script from "./DoctorDetails.vue?vue&type=script&lang=js&"
export * from "./DoctorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a77a4f7",
  null
  
)

export default component.exports